<div class="a-select-autocomplete"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.has-select]="searchValue">

  <div class="a-select-autocomplete__optional" *ngIf="isOptional">{{ 'ASelect.Optional' | translate }}</div>

  <div class="a-select-autocomplete__inner" 
    [class.is-disabled]="isDisabled"
    [class.has-value]="(!isMultiple && control.value) || (isMultiple && (filterParams$ | async).filters.query)"
    [class.has-error]="control.invalid && isSubmitted">
    
    <div class="a-select-autocomplete__items-bg" *ngIf="showItems" (click)="showDropdown(false)"></div>
    <div class="a-select-autocomplete__items" @slideInOut *ngIf="showItems"
      [class.open-top]="openPositionTop">
      <div class="a-select-autocomplete__items-inner is-scroll" #scrolledEl
        infinite-scroll
        [infiniteScrollThrottle]="200"
        [infiniteScrollContainer]="scrolledEl"
        [infiniteScrollDisabled]="currentPage === null"
        (scrolled)="!loadingResults && onScrollDown($event)">
        <div class="a-select-autocomplete__item"
          *ngFor="let item of itemsList; let i = index;" 
          [id]="'a-select-item-id-' + i"
          [class.active]="isMultiple
            ? selectedItem && selectedItem.length ? checkIfActive(item) : false
            : selectedItem && item[valueKey] === selectedItem[valueKey]"
          (click)="selectItem(item);">
          <div>{{ item[labelKey] }}</div>
        </div>
      </div>
      <div class="a-select-autocomplete__line-loader" @opacityInOut
        *ngIf="loadingResults && itemsList && itemsList.length !== 0 
          && (((filterParams$ | async).filters.query && (filterParams$ | async).filters.query !== '') 
          || (filterParams$ | async).filters.toPush) ">
      </div>
      <div class="a-select-autocomplete__nothing" 
        *ngIf="loadingResults && itemsList && itemsList.length === 0 
          && (filterParams$ | async).filters.query && (filterParams$ | async).filters.query !== ''">
        {{ 'ASelect.Loading' | translate }}
      </div>
      <div class="a-select-autocomplete__nothing" 
        *ngIf="!loadingResults && itemsList && itemsList.length === 0 
          && (filterParams$ | async).filters.query && (filterParams$ | async).filters.query.length > startSearchLength">
        <b>{{ 'ASelect.NothingFoundChangePhrase' | translate }}</b>
      </div>
      <div class="a-select-autocomplete__nothing"
        *ngIf="initialLoading">
        {{ 'ASelect.Loading' | translate }}
      </div>
      <div class="a-select-autocomplete__nothing"
        *ngIf="!initialLoading && !loadingResults && itemsList && itemsList.length === 0
          && (filterParams$ | async).filters.query === ''">
        {{ 'ASelect.StartTyping' | translate }}
      </div>
      <div class="a-select-autocomplete__nothing" 
        *ngIf="startSearchLength && !loadingResults && itemsList && itemsList.length === 0 
          && (filterParams$ | async).filters.query !== '' && (filterParams$ | async).filters.query <= startSearchLength">
        {{ 'ASelect.ContinueTyping' | translate }}
      </div>
    </div>

    <div class="a-select-autocomplete__input-box">
      <input #selectEl
        placeholder=" "
        type="text"
        [ngModel]="searchValue"
        (input)="findResult($event.target['value'])"
        (focus)="onFocus()" 
        (blur)="onBlurAction()">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__x" 
        *ngIf="isMultiple && (filterParams$ | async).filters.query !== ''"
        (click)="clear()">
      </i>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown(showItems ? false : true); showItems && selectEl.focus();">
      </i>
    </div>
  </div>

  <div class="a-select-autocomplete__selected" *ngIf="isMultiple && selectedItem && selectedItem.length">
    <div class="a-select-autocomplete__selected__item" *ngFor="let item of selectedItem">
      {{ item[labelKey] }} <i class="app-ico-mask app-ico-mask__x" (click)="removeSelected(item)"></i>
    </div>
  </div>
</div>